module.exports = __webpack_public_path__ + "static/img/007.fb254b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/templates/sotet-konyha/samples/007.jpg
// module id = 889
// module chunks = 0